import React from "react";
import { AptPackage } from "../../../utils/api/apartmentRentalsAPI";
import { fmtAmount } from "./bookingPricing";

interface Props {
  childrenPricing: NonNullable<AptPackage["childrenPricing"]>;
  childrenCount: number;
  childrenAges: number[];
  setChildrenAges: React.Dispatch<React.SetStateAction<number[]>>;
  currency?: string;
}

const ChildrenAgesBlock: React.FC<Props> = ({
  childrenPricing, childrenCount, childrenAges, setChildrenAges, currency,
}) => (
  <div className="pab-child-ages">
    <div className="pab-child-ages__head">
      <span className="ic">👨‍👩‍👧</span>
      <div>
        <div className="pab-child-ages__title">Uzrast djece</div>
        <div className="pab-child-ages__sub">Cijena po noći ovisi o godištu</div>
      </div>
    </div>
    <div className="pab-child-ages__body">
      {Array.from({ length: childrenCount }).map((_, i) => {
        const age = childrenAges[i];
        const hasAge = age != null && age > 0;
        const rule = hasAge ? childrenPricing.find(
          (r) => age >= r.ageFrom && (r.ageTo == null || age < r.ageTo)
        ) : undefined;
        const badge = hasAge ? (() => {
          if (!rule) return { text: "puna cijena", cls: "muted" };
          if (rule.priceType === "free") return { text: "besplatno", cls: "ok" };
          if (rule.priceType === "adult") return { text: "puna cijena", cls: "muted" };
          return { text: `${fmtAmount(rule.pricePerNight ?? 0, currency)} / noć`, cls: "accent" };
        })() : null;
        return (
          <div key={i} className="pab-child-ages__row">
            <div className="pab-child-ages__idx">{i + 1}</div>
            <div className="pab-child-ages__input-wrap">
              <input
                className="pab-input pab-child-ages__input"
                type="number" min={0} max={17}
                inputMode="numeric"
                placeholder="npr. 7"
                value={age > 0 ? age : ""}
                onChange={(e) => setChildrenAges((prev) => {
                  const next = [...prev];
                  next[i] = Number(e.target.value);
                  return next;
                })}
              />
              <span className="pab-child-ages__unit">godina</span>
            </div>
            {badge && <span className={`pab-badge pab-badge--${badge.cls}`}>{badge.text}</span>}
          </div>
        );
      })}
    </div>
  </div>
);

export default ChildrenAgesBlock;
